
import { mapState, mapActions } from "pinia"
import { useStore } from "../../store/PiniaStore"
import { defineComponent } from "vue"
import PageHeader from "../PageHeader.vue"
import ListOfOrders from "./ListOfOrders.vue"
import OrderFilters from "./OrderFilters.vue"
import LoadingIndicator from "../LoadingIndicator.vue"
import { filterOrderHistory } from "@/lib/HelperFns"
import { IOrder } from "../../lib/InterfacesAndTypes"
import { VueRouterInst } from "../../InitRoutesPlugins"
import { AxiosError } from "axios"

export default defineComponent({
	name: 'OrderManagementScreen',
	data: () => ({
		loading: {
			page: false,
		},
		isSaving: false,
		isInitial: true,
		filters: {
			startDate: null,
			endDate: null,
			statuses: [],
		},
		fetchedOrderMap: {} as Record<number, IOrder>,
		filteredOrders: [] as any[],
	}),
	components: {
		PageHeader,
		LoadingIndicator,
		ListOfOrders,
		OrderFilters,
	},
	computed: {
		...mapState(useStore, ['orders', 'orderMap']),
	},
	methods: {
		...mapActions(useStore, ['uploadOrder', 'fetchOrderList']),
		updateFilters(newFilters: any) {
			this.filters = { ...newFilters };
			console.log('Filters updated:', this.filters);
			this.updateFilteredOrders()
		},

		clearFilters() {
			this.filters = {
				startDate: null,
				endDate: null,
				statuses: [],
			};
			console.log('Filters cleared');
			this.updateFilteredOrders()
		},

		onOrderFileSelected(event: Event) {
			const input = event.target as HTMLInputElement
			if (!input.files?.length) {
				return
			}
			this.readFile(input.files)
		},

		async readFile(inputFiles: FileList) {
			const inputFile: File = inputFiles[0]

			console.log('file upload', inputFile)
			const fileExists = !!inputFile

			if (fileExists) {
				if (!inputFile.name.toLowerCase().endsWith('.csv')) {
					console.error('You must upload a .csv file!')
					return
				}
				try {
					const result = await this.uploadOrder(inputFile)
					console.log('uploadOrder result', result)
					const message = `Order uploaded successfully.<br>
					<a href="#/order-detail/${result.orderId}">Order ID: ${result.orderId}</a><br>
					Order: ${result.orderName}<br>
					Client: ${result.client}`
					this.$buefy.toast.open({
						duration: 8000,
						message: message,
						pauseOnHover: true,
						type: 'is-success',
					})
					VueRouterInst.push({ path: `/order-detail/${result.orderId}` })
				} catch (err: any) {
					console.error('Failed to upload order', err)
					if (err instanceof AxiosError) {
						console.error('AxiosError', err.response?.data)
						this.$buefy.toast.open({
							duration: 16000,
							message: `Failed to upload order.<br>Error: ${err.response?.data.errorMessage}<br>Please try again.`,
							type: 'is-danger',
						})
					}
				}
			} else {
				console.error('You must upload a .csv file!')
				this.$buefy.toast.open({
					duration: 8000,
					message: `Failed to upload order.<br>File must be a .csv file.<br>Please try again.`,
					type: 'is-danger',
				})
			}
		},

		updateFilteredOrders() {
			const map = this.fetchedOrderMap;
			console.log({map})
			this.filteredOrders = filterOrderHistory(Object.values(map), {
				startDate: this.filters.startDate,
				endDate: this.filters.endDate,
				statuses: this.filters.statuses,
			});
		},
	},
	async mounted() {
		console.log('OrderManagementScreen mounted')
		this.loading.page = true;
		const orderMap = await this.fetchOrderList()
		this.fetchedOrderMap = orderMap
		this.updateFilteredOrders()
		this.loading.page = false;
	},
})
